function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Import External Modules */
import React from 'react';
import { connect } from 'react-redux';

/* Import Leverege Modules */
import { ApiProvider } from '@leverege/api-redux';
import { Pane, Toast } from '@leverege/ui-elements';
import { v4 } from '@leverege/base62-util';
import I18N from '@leverege/i18n';

/* Import Local Modules */
import DefaultRoleSelector from "../../role/RoleSelector.js";
import CreateTemporaryUserForm from "./CreateTemporaryUserForm.js";
import S from './CreateTemporaryUserEditor.css';
const {
  t
} = I18N.ns('userManagement.temporaryUser.CreateEditor');

/**
 * User editor.
 */
class CreateTemporaryUserEditor extends React.Component {
  /* Initialize Static Variables */
  static contextType = ApiProvider.Context;

  /**
   * Constructs component.
   */
  constructor(props) {
    super(props);
    this.state = {
      newUserFormKey: Date.now()
      // value,
      // roles,
    };
  }

  /**
   * Sends user changes to user change handler function prop.
   */
  sendChange = () => {
    const {
      onChange,
      eventData
    } = this.props;
    const {
      roles,
      value
    } = this.state;
    onChange({
      data: eventData,
      value: {
        roles,
        ...value
      }
    });
  };

  /**
   * Handles role change events.
   */
  onRoleChange = event => {
    this.setState({
      roles: event.value
    }, this.sendChange);
  };

  /**
   * Handles local update events.
   */
  onLocalUpdate = ({
    value
  }) => {
    this.setState({
      value
    }, this.sendChange);
  };

  /**
   * Render component.
   */
  render() {
    // Get parameters
    const {
      projectId,
      roleSelector: RoleSelector = DefaultRoleSelector,
      selectorProps,
      getResourceName
    } = this.props;
    const {
      roles,
      selectionType,
      newUserFormKey,
      value
    } = this.state;

    // Initialize role selector
    const roleSelector = /*#__PURE__*/React.createElement(RoleSelector, _extends({}, selectorProps, {
      simple: true,
      projectId: projectId
      // user={user} 
      ,
      value: roles,
      variants: selectorProps?.variants,
      roleFilter: selectorProps?.roleFilter,
      onChange: this.onRoleChange,
      requireRoles: true
    }));

    // Return component
    return /*#__PURE__*/React.createElement(Pane, {
      className: S.editor
    }, /*#__PURE__*/React.createElement(CreateTemporaryUserForm, {
      getResourceName: getResourceName,
      key: newUserFormKey,
      type: selectionType,
      variants: selectorProps?.variants,
      roleFilter: selectorProps?.roleFilter,
      value: value,
      roleSelector: roleSelector,
      onChange: this.onLocalUpdate
    }));
  }
}

/* Export and Connect Module */
export default connect()(CreateTemporaryUserEditor);